import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Input } from 'reactstrap'

const LookupField = ({ field, value, onChange, base, initialOptions = [] }) => {
  const [ query, setQuery ] = useState('')
  const [ options, setOptions ] = useState([])
  const [ error, setError ] = useState('')
  const [ loading, setLoading ] = useState(false)
  const selectedIds = JSON.stringify(field.multiple ? value || [] : value ? [ value ] : [])
  useEffect(() => {
    let alive = true
    setLoading(true)
    const timer = setTimeout(() => {
      axios.get(`${base}/options`, { params: { kind: field.kind, q: query.trim(), ids: JSON.parse(selectedIds) } })
        .then((response) => { if (alive) { setOptions(response.data.options || (response.data.products || []).map((item) => ({ value: item.id, label: item.label }))); setError('') } })
        .catch(() => { if (alive) setError('Pilihan gagal dimuat. Coba cari ulang.') })
        .finally(() => { if (alive) setLoading(false) })
    }, 250)
    return () => { alive = false; clearTimeout(timer) }
  }, [ base, field.kind, query, selectedIds ])
  const ids = JSON.parse(selectedIds)
  const stored = ids.filter((id) => !options.some((option) => String(option.value) === String(id))).map((id) => initialOptions.find((option) => String(option.value) === String(id)) || ({ value: id, label: `#${id} (data tersimpan)` }))
  const allOptions = [ ...options, ...stored ]
  return <>
    <Input value={ query } onChange={ (event) => setQuery(event.target.value) } placeholder='Ketik sebagian SKU / nama / email / ID' className='mb-1' aria-label={ `Cari ${field.label}` } />
    <div aria-live='polite' className='small text-muted mb-1'>{ loading ? 'Mencari...' : error || `${options.length} hasil; klik pilihan di bawah.` }</div>
    <Input type='select' aria-label={ `Pilih ${field.label}` } multiple={ field.multiple } size={ 5 } required={ field.required } value={ value || (field.multiple ? [] : '') } onChange={ (event) => { const next = field.multiple ? Array.from(event.target.selectedOptions).map((option) => option.value) : event.target.value; onChange(next) } }>
      { !field.multiple && <option value=''>Pilih / kosongkan</option> }
      { allOptions.map((option) => <option key={ option.value } value={ option.value }>{ option.label }</option>) }
    </Input>
    { !loading && !error && options.length === 0 && <div className='small text-muted'>Tidak ada hasil yang cocok. Untuk auction, produk harus memiliki inventory aktif.</div> }
    { field.multiple && <small>Ctrl / Cmd + klik untuk memilih beberapa produk.</small> }
  </>
}

export default LookupField
